import React from 'react';
import { useHistory } from 'react-router';
import { useDispatch } from 'react-redux';
import { api } from '../../store/api';
import { contractReset } from '../../store/actions/SelectedContract';

const LogOutCallback: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  React.useEffect(() => {
    dispatch(api.util.resetApiState());
    dispatch(contractReset());
    history.push('/');
  }, []);

  return null;
};

export default LogOutCallback;
